<template>
  <v-autocomplete
    label="Post Orders"
    v-model="site"
    :items="postOrders"
    item-value="id"
    item-title="site"
    :loading="loading"
    :error-messages="combinedErrorMessages"
    v-bind="$attrs"
  >
  </v-autocomplete>
</template>

<script setup lang="ts">
import { computed, type PropType } from 'vue'
import type { IPostOrderData } from '@/models/post-order'
import { useFetchPostOrders } from '@/composables/post-order'

const site = defineModel<null | IPostOrderData | number>({ default: null })

const { postOrders, isLoading: loading, error: fetchError } = useFetchPostOrders()

const props = defineProps({
  errorMessages: {
    type: [String, Array] as PropType<string | string[]>,
    default: () => []
  }
})

const combinedErrorMessages = computed(() => {
  let error: string[] = []

  if (fetchError.value) {
    error.push(fetchError.value.message)
  }
  if (Array.isArray(props.errorMessages)) {
    error.push(...props.errorMessages)
  } else {
    error.push(props.errorMessages)
  }

  return error
})
</script>
